// Function to get an object from sessionStorage
export const getObjectFromSessionStorage = key => {
    try {
        const storedObj = sessionStorage.getItem(key);
        return storedObj ? JSON.parse(storedObj) : null;
    } catch (error) {
        console.error(`Error getting object from sessionStorage: ${error}`);
        return null;
    }
  }
  
  // Function to set an object in sessionStorage
  export const setObjectInSessionStorage = (key, obj) => {
    try {
        sessionStorage.setItem(key, JSON.stringify(obj));
    } catch (error) {
        console.error(`Error setting object in sessionStorage: ${error}`);
    }
  }
  
  // Function to update a specific property of an object in sessionStorage
  export const updateObjectInSessionStorage = (key, property, value) => {
    try {
        const existingObj = getObjectFromSessionStorage(key);
        if (existingObj) {
            existingObj[property] = value; // Update the property
            setObjectInSessionStorage(key, existingObj); // Save the updated object
        } else {
            setObjectInSessionStorage(key, {[property]: value}); 
        }
    } catch (error) {
        console.error(`Error updating object in sessionStorage: ${error}`);
    }
  }